import { render, staticRenderFns } from "./tabbar.vue?vue&type=template&id=507e317f&scoped=true&"
import script from "./tabbar.vue?vue&type=script&lang=js&"
export * from "./tabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507e317f",
  null
  
)

export default component.exports